import React, {useState} from 'react';
import {Dialog, DialogContent,} from '@material-ui/core';
import MindfileItemView from './MindfileItemView';

function ItemViewDialog(props) {
  const { id, item, setItem, columnMap, canSelect, showToolbar, showStatusIcon, handleItemChange,
    isOpen, handleCancel, moveItems, removeItems, saveItems, folderList, addFolder, addFilterSelectByName, mindfileFilterValues,
    openDataView, mindfileUserLevel, getMindfileItem, mindfileDisplay, itemChangeCallback } = props;

  const [editOpen, setEditOpen] = useState(false);

  return (
      <Dialog open={isOpen} onClose={editOpen ? null : handleCancel}
        fullWidth maxWidth="md"
        PaperProps={{
          id: id,
          style: {
            width: 'calc(100% - (16px * 2))',
            maxWidth: '960px',
            margin: '16px',
            maxHeight: 'calc(100% - 32px)'
          }
        }}
      >
        <DialogContent style={{padding:'0'}}>
          <MindfileItemView
            item={item}
            handleClose={handleCancel}
            setItem={setItem}
            isEdit={editOpen}
            setEdit={(open) => setEditOpen(open)}
            columnMap={columnMap}
            handleItemChange={handleItemChange}
            initialDisplayType="preview"
            collapsed={false}
            saveItems={saveItems}
            moveItem={!moveItems ? null : moveItems.bind(this, [item.id])}
            removeItem={!removeItems ? null :removeItems.bind(this, [item.id])}
            folderList={folderList}
            addFolder={addFolder}
            mindfileFilterValues={mindfileFilterValues}
            openDataView={openDataView}
            showToolbar={showToolbar}
            showStatusIcon={showStatusIcon}
            canSelect={canSelect}
            mindfileUserLevel={mindfileUserLevel}
            getMindfileItem={getMindfileItem}
            mindfileDisplay={mindfileDisplay}
            itemChangeCallback={itemChangeCallback}
            addFilterSelectByName={(name, value) => {
              addFilterSelectByName(name, value);
              handleCancel();
            }}
          />
        </DialogContent>
      </Dialog>
  );
}

export default ItemViewDialog;
